import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card, CardBody, CardHeader,
  Container, Row, Col, Badge, Button, Table,
} from "reactstrap";
import { bookingsRepo } from "data/repositories/bookingsRepo";
import EmptyState from "components/EmptyState";

const STATUS_COLOR = { pending: "warning", confirmed: "success", cancelled: "danger" };
const STATUS_LABEL = { pending: "Bekliyor", confirmed: "Onaylandı", cancelled: "İptal" };

export default function MyBookings() {
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    setBookings(bookingsRepo.list());
  }, []);

  const handleCancel = (id) => {
    bookingsRepo.updateStatus(id, "cancelled");
    setBookings(bookingsRepo.list());
  };

  return (
    <>
      <div className="header bg-gradient-info pb-6 pt-5 pt-md-7">
        <Container fluid>
          <Row className="align-items-center">
            <Col>
              <h2 className="text-white mb-0">Rezervasyonlarım</h2>
            </Col>
            <Col className="text-right">
              <Button color="white" size="sm" tag={Link} to="/admin/bookings/new">
                + Yeni Rezervasyon
              </Button>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        <Card className="shadow">
          <CardHeader><h3 className="mb-0">Tüm Rezervasyonlar</h3></CardHeader>
          <CardBody>
            {bookings.length === 0 ? (
              <EmptyState title="Henüz rezervasyonunuz yok" />
            ) : (
              <Table className="align-items-center" responsive>
                <thead className="thead-light">
                  <tr>
                    <th>İşletme</th>
                    <th>Başlangıç</th>
                    <th>Gece</th>
                    <th>Durum</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {bookings.map((b) => (
                    <tr key={b.id}>
                      <td>{b.businessId}</td>
                      <td>{b.startDate || "-"}</td>
                      <td>{b.nights || "-"}</td>
                      <td>
                        <Badge color={STATUS_COLOR[b.status] || "secondary"}>
                          {STATUS_LABEL[b.status] || b.status}
                        </Badge>
                      </td>
                      <td>
                        {b.status === "pending" && (
                          <Button color="danger" size="sm" onClick={() => handleCancel(b.id)}>
                            İptal
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </CardBody>
        </Card>
      </Container>
    </>
  );
}
